module.exports = __webpack_public_path__ + "assets/prebid.054c59eb.svg";